import { settings } from "../../../customize/settings";
import { IStatoLavorazione } from "../../../interfaces/dettaglio/attributes/models";
import { IBaseError } from "../../../interfaces/errors";
import { IListResponse } from "../../../interfaces/rest";
import { getJWT } from "../../../lib/jwt";

const BASE_URL = `${settings.apiUrl}stato-lavorazione`;

export const getStatoLavorazione = async (id: number): Promise<IStatoLavorazione> => {
	const url = `${BASE_URL}/${id}`;
	const headers = new Headers();
	headers.append('Content-Type', 'application/json');
	const jwt = getJWT();
	if (jwt) headers.append('Authorization', 'Bearer ' + jwt);
	const response = await fetch(url, {
		method: "GET",
		headers: headers
	});
	const json: IStatoLavorazione | IBaseError = await response.json();
	if (response.status !== 200) throw json;
	return json as IStatoLavorazione;
}

export const getStatoLavorazioneList = async (): Promise<IListResponse<IStatoLavorazione>> => {
	const url = `${BASE_URL}/list`;
	const headers = new Headers();
	headers.append('Content-Type', 'application/json');
	const jwt = getJWT();
	if (jwt) headers.append('Authorization', 'Bearer ' + jwt);
	const response = await fetch(url, {
		method: "GET",
		headers: headers
	});
	const json: IListResponse<IStatoLavorazione> | IBaseError = await response.json();
	if (response.status !== 200) throw json;
	return json as IListResponse<IStatoLavorazione>;
}